// features/toasts/ToastManager.tsx
import { useEffect } from 'react';
import { removeToast } from './toastSlice';
import styles from './Toast.module.css';
import { ToastItem } from './ToastItem';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@app/store/types';

export const ToastManager = () => {
  // Правильный путь к тостам в стейте
  const toasts = useSelector((state: RootState) => state.toast.toasts) || [];
  const dispatch = useDispatch();

  useEffect(() => {
    const timers: NodeJS.Timeout[] = [];

    toasts.forEach((toast) => {
      const timer = setTimeout(() => {
        dispatch(removeToast(toast.id));
      }, toast.duration || 4000);
      timers.push(timer);
    });

    return () => timers.forEach(clearTimeout);
  }, [toasts, dispatch]);

  if (!toasts.length) return null;

  return (
    <div className={styles.container}>
      {toasts.map((toast) => (
        <ToastItem 
          key={toast.id} 
          toast={toast} 
          onRemove={() => dispatch(removeToast(toast.id))} 
        />
      ))}
    </div>
  );
};
